import { ActiveCallActions } from "./action";

export default function reduceActiveCalls(state, action) {
  switch (action.type) {
    case ActiveCallActions.SET_STATE:
      return {
        ...state,
        pendingCalls: action.payload.pendingCalls,
        pausedCalls: action.payload.pausedCalls,
        totalCalls: action.payload.totalCalls,
        concurrencyLimit: action.payload.concurrencyLimit,
        concurrentCalls: action.payload.concurrentCalls,
        lastUpdatedAt: Date.now(),
        isLoading: false,
      };
    case ActiveCallActions.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    default:
      return state;
  }
}
